import { Key } from '@phosphor-icons/react';

export default Key;
